exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".person-renderer__avatar {\n  display: inline;\n  vertical-align: bottom;\n}\n", ""]);

